export default function CounselingDetails() {
  const counselingTypes = [
    {
      id: 1,
      title: '유아·아동 상담',
      description: '아이들은 말보다 행동과 감정으로 마음을 표현합니다. 놀이와 정서 중심 상담을 통해 아이의 마음을 이해하고 건강한 소통과 성장을 도와드립니다.',
      image: 'https://public.readdy.ai/ai/img_res/27b947fe9d1e391009c4ecacbc3c89e5.jpg',
      items: ['정서 및 행동 문제', '학교생활 적응의 어려움', '또래 관계 문제', '불안 및 위축', '부모-자녀 관계 상담'],
      reverse: false
    },
    {
      id: 2,
      title: '청소년상담',
      description: '청소년기는 정체성과 관계 형성이 중요한 시기입니다. 자존감, 진로, 학업, 관계 문제 등 다양한 고민을 안전한 상담 환경에서 함께 탐색합니다.',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20study%20and%20counseling%20space%20for%20teenagers%20with%20modern%20minimalist%20design%20in%20soft%20neutral%20tones%20showing%20books%20and%20comfortable%20seating%20representing%20youth%20guidance%20and%20emotional%20support%20with%20warm%20lighting%20and%20calming%20atmosphere&width=800&height=600&seq=teen-counseling-002&orientation=landscape',
      items: ['학업 스트레스', '또래 관계 고민', '진로 및 정체성 탐색', '가족 갈등', '불안 및 우울'],
      reverse: true
    },
    {
      id: 3,
      title: '성인 상담',
      description: '삶의 다양한 역할 속에서 겪는 어려움을 전문적인 상담을 통해 이해하고 해결하도록 도와드립니다.',
      image: 'https://readdy.ai/api/search-image?query=Serene%20adult%20counseling%20space%20with%20comfortable%20modern%20furniture%20in%20calming%20sage%20green%20and%20beige%20tones%20with%20natural%20elements%20and%20soft%20lighting%20creating%20professional%20yet%20warm%20atmosphere%20for%20mental%20health%20therapy%20and%20emotional%20wellness&width=800&height=600&seq=adult-counseling-003&orientation=landscape',
      items: ['직장 스트레스 및 번아웃', '불안, 우울', '대인관계 문제', '자존감 문제', '삶의 방향 탐색'],
      reverse: false
    },
    {
      id: 4,
      title: '부부 상담',
      description: '파트너 관계는 삶의 질에 큰 영향을 미칩니다. 서로의 감정을 이해하고 의사소통을 회복하도록 도와드립니다.',
      image: 'https://readdy.ai/api/search-image?query=Intimate%20and%20peaceful%20couples%20counseling%20room%20with%20two%20comfortable%20chairs%20facing%20each%20other%20in%20warm%20terracotta%20and%20sage%20green%20tones%20with%20soft%20natural%20lighting%20creating%20safe%20space%20for%20relationship%20therapy%20and%20communication%20healing&width=800&height=600&seq=couple-counseling-004&orientation=landscape',
      items: ['의사소통의 어려움', '관계 회복', '신뢰 문제', '갈등 해결', '친밀감 회복'],
      reverse: true
    },
    {
      id: 5,
      title: '가족 상담',
      description: '가족은 서로에게 가장 큰 영향을 미치는 관계입니다. 가족 구성원 간의 이해를 돕고 관계 회복을 지원합니다.',
      image: 'https://readdy.ai/api/search-image?query=Warm%20family%20counseling%20space%20with%20circular%20seating%20arrangement%20in%20soft%20pastel%20colors%20and%20natural%20wood%20elements%20creating%20harmonious%20and%20safe%20environment%20for%20family%20therapy%20with%20gentle%20lighting%20and%20peaceful%20atmosphere&width=800&height=600&seq=family-counseling-005&orientation=landscape',
      items: ['가족 갈등', '부모-자녀 관계', '의사소통 문제', '가족 내 역할 갈등', '세대 간 이해'],
      reverse: false
    },
    {
      id: 6,
      title: '기업 상담',
      description: '직장 내 심리적 어려움은 개인의 삶과 조직 전체에 영향을 미칩니다. 직원들의 정신 건강을 지원하고 건강한 조직 문화를 만들어 가도록 전문적인 기업 상담 서비스를 제공합니다.',
      image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20corporate%20wellness%20counseling%20office%20with%20clean%20minimalist%20design%20in%20warm%20beige%20and%20sage%20green%20tones%20comfortable%20seating%20natural%20light%20plants%20and%20calming%20decor%20representing%20workplace%20mental%20health%20support%20and%20employee%20wellbeing%20program&width=800&height=600&seq=corporate-counseling-006&orientation=landscape',
      items: ['직장 내 스트레스 및 번아웃', '직원 간 대인관계 갈등', '리더십 및 소통 문제', '조직 내 심리적 안전감 구축', '직무 전환 및 퇴직 스트레스'],
      reverse: true
    }
  ];

  return (
    <section className="py-20 bg-[#FBF5F3]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-[26px] font-bold text-[#2C2C2C] mb-3">전문 상담 영역</h2>
          <p className="text-[15px] text-[#666666]">
            각 영역별 전문적이고 체계적인 상담을 제공합니다
          </p>
        </div>

        <div className="space-y-16">
          {counselingTypes.map((type) => (
            <div
              key={type.id}
              className={`flex flex-col ${type.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-10 lg:gap-14`}
            >
              <div className="w-full lg:w-2/5">
                <div className="rounded-2xl overflow-hidden shadow-lg">
                  <div className="relative w-full h-72">
                    <img
                      src={type.image}
                      alt={type.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-[#A8B5A0]/10"></div>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-3/5 flex flex-col justify-center">
                <h3 className="text-[20px] font-bold text-[#2C2C2C] mb-3">{type.title}</h3>
                
                <p className="text-[14px] text-[#666666] leading-relaxed mb-5">
                  {type.description}
                </p>

                <h4 className="text-[15px] font-semibold text-[#2C2C2C] mb-3">주요 상담 내용</h4>
                
                <ul className="space-y-2">
                  {type.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#A8B5A0] mt-[6px] flex-shrink-0"></div>
                      <span className="text-[13px] text-[#666666]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
